const getters = {
  getClose(state) {
    return state.sidebarShow;
  }
};

export default {
  getters
};
